import "./assets/ChatBotQuestao.css";
import { URL } from "../../variables";

// Library Imports
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Card, Form, Modal } from "react-bootstrap";
import {
  FaPaperclip,
  FaTrash,
  FaRedo,
  FaArrowLeft,
  FaEdit,
  FaSave } from
"react-icons/fa";
import CircularProgress from "@mui/material/CircularProgress";
import { connect, useDispatch } from "react-redux";

// Component Imports
import ContextForm from "./components/ContextForm";
import ValidationModal from "./components/ValidationModal";

// Service Imports
import { logout, QuestionIA } from "../../actions/AppActions";
import { MdCheck, MdEdit } from "react-icons/md";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { usePreferences } from "../../contexts/PreferencesContext";
import { getQuestionTypeLabel } from "./questionLabels";
const GENERATING_MESSAGE_KEYS = [
"loading_question_generating_response",
"loading_question_thinking",
"loading_question_processing",
"loading_question_calculating"];

const ChatBotQuestao = ({ token }) => {const { t } = usePreferences();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_questions, setLoadingQuestions] = useState(false);

  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);
  const { id } = useParams();
  const history = useHistory();

  const [context, setContext] = useState({
    tema: "",
    disciplina_id: id,
    disciplina: '',
    tipoQuestao: "",
    nivelDificuldade: "",
    nivelEscolaridade: "",
    topicosEspecificos: "",
    quantidadeAlternativas: 0,
    contexto: ""
  });
  const [isEditingContext, setIsEditingContext] = useState(true);
  const [editingMessageIndex, setEditingMessageIndex] = useState(null);
  const [editedMessage, setEditedMessage] = useState("");
  const [questionId, setQuestionId] = useState(null); // Novo estado para armazenar o ID da questão
  const chatBodyRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [messageIndexToValidate, setMessageIndexToValidate] = useState(null);
  const [categoria_id, setCategoriaId] = useState(id);

  const dispatch = useDispatch();


  useEffect(() => {
    if (categoria_id != null) {
      fetchQuestions(categoria_id);
    }
    return () => {

    };
  }, [categoria_id]);


  useEffect(() => {
    // fetchQuestions()
    return () => {

    };
  }, []);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setLoadingMessageIndex(
        (prevIndex) => (prevIndex + 1) % GENERATING_MESSAGE_KEYS.length
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [loading]);

  useEffect(() => {
























    // const savedContext = localStorage.getItem("context");
    // console.log('conntext', savedContext)
    // if (savedContext) {
    // setContext(JSON.parse(savedContext));
    // setIsEditingContext(false);
    // }
  }, []);const handleContextSubmit = (contextData) => {if (isEditingContext) {setContext(contextData); // localStorage.setItem("context", JSON.stringify(contextData));
      setIsEditingContext(false);}};const handleEditContext = () => {setIsEditingContext(true);};const handleVincularMessage = async () => {dispatch(QuestionIA(messageIndexToValidate));history.push(`/questoes/register/${messageIndexToValidate.categoria_id}`);};const fetchQuestions = async (categoria_id) => {try {setLoadingQuestions(true);const response = await fetch(`${URL}api/faculdade/listar_questoes?categoria_id=${categoria_id}`, { method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept": "application/json"
          },
          body: JSON.stringify({})
        });
      const resp = await response.json();

      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');localStorage.removeItem('user');
        // this.setState({redirect:true,path:'/'});
        dispatch(logout());
        return;
      }
      if (resp.errors != null || resp.error != null) {
        let errors = Object.values(resp.errors);
        let erro = '';
        for (let i = 0; i < errors.length; i++) {
          if (i != errors.length - 1)
          erro += errors[i] + '\n';else

          erro += errors[i];
        }
        console.log(erro);

        //   setTimeout(()=>{
        //     this.get_processo();
        //   });
      } else
      {
        setMessages(resp.questoes); // Store the question ID

      }
      setLoadingQuestions(false);

    } catch (error) {
      console.error("Erro ao salvar a questão:", error);
    }
  };

  const saveQuestion = async (questionData) => {
    setLoading(true);

    try {
      console.log(questionData);
      const response = await fetch(`${URL}api/faculdade/criar_questao`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(questionData)
      });
      const resp = await response.json();

      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');localStorage.removeItem('user');
        // this.setState({redirect:true,path:'/'});
        dispatch(logout());
        return;
      }
      if (resp.errors != null || resp.error != null) {
        let errors = Object.values(resp.errors);
        let erro = '';
        for (let i = 0; i < errors.length; i++) {
          if (i != errors.length - 1)
          erro += errors[i] + '\n';else

          erro += errors[i];
        }
        console.log(erro);

        //   setTimeout(()=>{
        //     this.get_processo();
        //   });
      } else
      {
        console.log(resp);
        setMessages((prevMessages) => [
        resp.questao,
        ...prevMessages]
        );
      }
      setLoading(false);


    } catch (error) {
      setLoading(false);

      console.error("Erro ao salvar a questão:", error);
    }
  };

  const handleSend = useCallback(() => {
    if (!context.tema) return;

    saveQuestion(context);
    return;

  }, [context, token]);



  const handleEditMessage = (index) => {
    setEditingMessageIndex(index);
    setEditedMessage(messages[index].text);
  };

  const handleSaveEdit = (index) => {
    const updatedMessages = [...messages];
    updatedMessages[index].text = editedMessage;
    setMessages(updatedMessages);
    setEditingMessageIndex(null);
    setEditedMessage("");
  };

  const handleCancelEdit = () => {
    setEditingMessageIndex(null);
    setEditedMessage("");
  };

  useEffect(() => {
    if (chatBodyRef.current)
    chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
  }, [messages]);

  const handleShowModal = (index) => {
    setMessageIndexToValidate(index);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setMessageIndexToValidate(null);
  };

  return (
    <div className="chat-container">
     

      <div className="main-content">
        <Card className="context-form">
          <Card.Body>
            <div className="context-section">

              {isEditingContext ?
              <ContextForm setCategoriaId={(e) => {
                setCategoriaId(e);
              }} onSubmit={handleContextSubmit} id={id} initialData={context} /> :

              <>
                  <Card.Title style={{ fontSize: '1.5rem', color: 'black', fontWeight: 'bold' }}>{t("ui_contexto_da_questao_36e5d6aa")}</Card.Title>
                  <Card.Text>
                    <p style={{ marginBottom: 5 }}><b>{`${t("label_subject")}:`}</b> {context.disciplina}</p>
                    <p style={{ marginBottom: 5 }}><b>{t("ui_tipo_de_questao_2e2adb09")}</b> {context.tipoQuestao}</p>
                    <p style={{ marginBottom: 5 }}><b>{`${t("label_alternative_count")}:`}</b> {context.quantidadeAlternativas || t("value_not_specified")}</p>
                    <p style={{ marginBottom: 5 }}><b>{t("ui_nivel_de_escolaridade_d4702d75")}</b> {context.nivelEscolaridade}</p>
                    <p style={{ marginBottom: 5 }}><b>{t("ui_nivel_de_dificuldade_0d029649")}</b> {context.nivelDificuldade}</p>
                    <p style={{ marginBottom: 5 }}><b>{`${t("label_main_theme")}:`}</b> {context.tema}</p>
                    <p style={{ marginBottom: 5 }}><b>{`${t("label_context")}:`}</b> {context.contexto || t("value_not_specified")}</p>
                  </Card.Text>


                  {loading &&
                <div className="loading-indicator d-flex justify-content-center">
                <CircularProgress size={24} />
                <span className="ms-3 text-muted">
                  {t(GENERATING_MESSAGE_KEYS[loadingMessageIndex])}
                </span>
              </div>
                }
                 
                 {!loading && <footer className="chat-footer d-flex justify-content-between align-items-center">
                  <div className="d-flex">
                  
                  {
                    <Button onClick={handleEditContext} variant="outline-primary" className="me-2">
                      <FaArrowLeft />{t("ui_editar_criar_novo_contexto_0450e752")}
                    </Button>
                    }
                  {/* <Button variant="outline-primary ms-2" onClick={handleEditContext}>
                                <MdEdit/> Editar/Criar Novo Contexto
                               </Button> */}
                  </div>
                  
                  <Button
                    variant="success"
                    onClick={handleSend}
                    disabled={isEditingContext}>{t("ui_gerar_questao_d655bb9d")}

                    <MdCheck />
                  </Button>
            </footer>}

                </>
              }
            </div>


          </Card.Body>
        </Card>

        <div className="chat-section mt-4">
          <div className="chat-body" ref={chatBodyRef}>
          <Card className="message mb-4">
          <Card.Body>
          <Card.Title style={{ fontSize: '1.5rem', color: 'black', fontWeight: 'bold' }}>{t("ui_questoes_geradas_pendentes_de_validacao_18471a7e")}</Card.Title>
          <p style={{ fontSize: '1rem', color: 'black' }}>{t("ui_altere_a_disciplina_do_contexto_para_ver_questao_p_815d5e95")}</p>
            {loading_questions == false ? <>
            {messages.length == 0 && <><hr /><p style={{ marginBottom: 0 }}>{t("empty_no_questions_found")}</p></>}
           
            {messages.map((msg, index) =>
                  <div key={index}>
                  <hr />
                  {editingMessageIndex === index ?
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={editedMessage}
                      onChange={(e) => setEditedMessage(e.target.value)} /> :


                    <>
                      {
                      <div>
                          <div style={{ marginBottom: "10px" }}>
                            <strong>{t("label_question_type_modal")}: </strong><span>{getQuestionTypeLabel(msg.tipo_questao, t)}</span>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                            <strong>{t("label_subject")}: </strong><span>{msg.categoria.name}</span>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                            <strong>{t("label_generated_at")}: </strong><span>{moment(msg.created_at).format('DD/MM/YYYY HH:mm')}</span>
                          </div>
                          <div
                          className="solucao"
                          style={{ marginBottom: "10px" }}>

                            <strong>{t("legacy_palavras_chaves")}:</strong>{" "}
                            <span>
                              {msg.palavras_chaves}
                            </span>
                          </div>
                          <div
                          className="enunciado"
                          style={{ marginBottom: "10px" }}>

                            <strong>{t("label_statement")}:</strong>{" "}
                            <span>
                              {msg.enunciado}
                            </span>
                          </div>
                          
                          
                          {msg.tipo_questao == 'Questão objetiva' && <div
                          className="alternativas"
                          style={{ marginBottom: "10px" }}>

                            <strong>{t("label_alternatives")}</strong>
                            <div style={{ marginTop: "5px" }}>
                              {msg?.alternativas?.map((alt, index) =>
                            <div
                              key={index}
                              style={{ marginBottom: "5px" }}>

                                  {alt}
                                </div>
                            )}
                            </div>
                          </div>}

                          <div
                          className="solucao"
                          style={{ marginBottom: "10px" }}>

                            <strong>{msg.tipo_questao == 'Questão objetiva' ? t("legacy_solucao") : t("label_answer")}:</strong>{" "}
                            <span>
                              {msg.resposta_solucao}
                            </span>
                          </div>


                        </div>
                      }
                    </>
                    }
                  {editingMessageIndex === index ?
                    <>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleSaveEdit(index)}>

                        <FaSave />{t("action_save")}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        className="ms-2"
                        onClick={handleCancelEdit}>{`
                        ${t("legacy_cancelar")}
                      `}
                      </Button>
                    </> :

                    <>
                      {/* <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleEditMessage(index)}
                           >
                            <FaEdit /> Editar
                           </Button> */}
                      {
                      <Button
                        variant="info"
                        size="sm"
                        className="ms-0"
                        onClick={() => handleShowModal(msg)}>{t("ui_validar_questao_787fc7b5")}

                        <FaPaperclip />
                        </Button>
                      }
                    </>
                    }
              </div>
                  )}
            </> : <div className="d-flex justify-content-center">
            <CircularProgress />
            </div>}

 </Card.Body>

            </Card>
            
          </div>

          {/* <footer className="chat-footer d-flex justify-content-between align-items-center">
                <div>
                  <Button
                    variant="outline-danger"
                    className="me-2"
                    onClick={handleClearMessages}
                  >
                    <FaTrash /> Limpar
                  </Button>
                </div>
                </footer> */

          }

        </div>

      </div>

      <ValidationModal
        show={showModal}
        onClose={handleCloseModal}
        onValidate={handleVincularMessage}
        id={id}
        isEditingContext={isEditingContext} />

    </div>);

};

const mapStateToProps = (state) => ({
  token: state.AppReducer.token
});

export default connect(mapStateToProps)(ChatBotQuestao);
